import {uniq} from "lodash"

import {BasketInputItem, BasketItemType, BasketTotalWithBreakDown} from "@irati/types"
import dealService from "@irati/deals/services/dealsGraph"
import productService from "@irati/products/services/product"
import totals, {TotalsData} from "@shared/checkout/utils/basket/totals"
import totalsCashback from "@shared/checkout/utils/basket/cashbackTotals"
import currencyService from "@irati/currency/services/currency"

export default function optimisticBasket(items: BasketInputItem[]): Promise<BasketTotalWithBreakDown> {
  return getDataForItems(items).then((data) => {
    return totals(items, data) as BasketTotalWithBreakDown
  })
}

export function optimisticCashbackBasket(items: BasketInputItem[]): Promise<BasketTotalWithBreakDown> {
  return getDataForItems(items).then((data) => {
    const currency = data.deals[0].productConfig?.products[0]?.salePrice?.currency!
    return currencyService.getFPCashbackForCurrency(currency).then(({fpExchangeRate}) => {
      return totalsCashback(items, data, fpExchangeRate) as BasketTotalWithBreakDown
    })
  })
}

function getDataForItems(items: BasketInputItem[]) {
  const isRewards = items[0]?.entityType === BasketItemType.FlexiReward
  const dealIds = uniq(items.map((item) => item.entityId!))
  const productIds = uniq(items.map((item) => item.productId!))
  const dealsRequest = dealService.list({uuids: dealIds, isRewards})
  const productsRequest = productService.list({ids: productIds})

  return Promise.all([dealsRequest, productsRequest]).then(([deals, products]) => {
    return {
      deals: deals.results,
      products
    } as TotalsData
  })
}
